import React from 'react';
import OptimizeButton from 'components/molecules/optimize-button';
import {BaseTeamsCombinations} from 'components/organisms/teams-combinations/components/base-teams-combinations';

class DesktopTeamsCombinations extends BaseTeamsCombinations {
    getView(params) {
        const lineupsQuantity = this.getLineupsQuantity();
        const {content, combosQuantity} = params;

        return (
            <div className="tab-content combo-summary-content">
                <div className="players-heading">
                    <strong>{combosQuantity}</strong> Teams Combo Used |<strong>{lineupsQuantity}</strong> Lineups
                    <OptimizeButton />
                </div>
                <div className="players-used-table table-holder">
                    <div className="table-scroll">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Teams</th>
                                    <th>Exp%</th>
                                    <th>
                                        Exp.
                                        <br />
                                        max
                                    </th>
                                </tr>
                            </thead>
                            {content}
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export {DesktopTeamsCombinations};
